export default {"src":"https://cdn.tanzhi.cn/_next/static/media/hot.27392519.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};